import { Autocomplete, Box, Button, Checkbox, Modal, TextField } from "@mui/material";
import { Close, CheckBoxOutlineBlank, CheckBox } from '@mui/icons-material';
import { useEffect, useState } from "react";

const oicon = <CheckBoxOutlineBlank fontSize="small" />;
const checkedIcon = <CheckBox fontSize="small" />;

const style = {
    overflow: 'hidden',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    maxWidth: '60vw',
    minWidth: '50vw',
    minHeight: '60vh',
    maxHeight: '90vh',
    bgcolor: 'background.paper',
    borderRadius: '1rem',
    boxShadow: 24,
    p: 4,
    display: 'flex',
    flexDirection: 'column',
    padding: '1rem',
    position: "absolute"
};

export function ModalSendEmailGroup({ api, show, onClose, data, type, functionFormatData, orderKeys }) {
    const [duties, setDuties] = useState([]);
    const [selectedDuties, setSelectedDuties] = useState([])
    const [users, setUsers] = useState([])
    const [selectedUsers, setSelectedUsers] = useState([])
    const disabledButton = (selectedDuties.length === 0 && selectedUsers.length === 0) || data.length === 0

    useEffect(() => {
        async function start() {
            const [responseDuties, responseUsers] = await Promise.all([
                api.get('/users/allDuty'),
                api.get('/users')
            ])
            setDuties(responseDuties)
            setUsers(responseUsers
                .filter(user => !user.inativo && !user.email.includes('ai2b'))
                .map(item => item.email)
            )
        }

        start()
    }, [])

    const onClickSendEmail = async () => {
        try {
            const formattedData = functionFormatData ? functionFormatData(data) : data
            const body = {
                type,
                duties: selectedDuties.map(duty => duty.value),
                users: selectedUsers,
                data: formattedData,
                orderKeys,
            }
            console.log(body)
            await api.post('/report/send-mail', body)
            onClose()
        } catch (error) {
            console.log('Error enviar email')
            console.log(error)
        }
    }

    return (
        <Modal open={show} onClose={onClose} aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description">
            <Box sx={style}>
                <header style={{ paddingBottom: "6px", borderBottom: "1px solid gray", flexDirection: 'row', display: 'flex', justifyContent: 'space-between' }}>
                    <div>
                        <h2 style={{ padding: 0, margin: 0, color: "#3f3f3f" }}>Selecione o grupo para envio do relatório</h2>
                    </div>
                    <div style={{ textAlign: 'end', padding: 0, margin: 0 }}>
                        <Close onClick={onClose} sx={{
                            ":hover": {
                                color: 'grey', backgrounColor: 'white'
                            }
                        }} />
                    </div>
                </header>
                <div
                    style={{
                        marginTop: 16,
                        display: 'flex',
                        flexDirection: 'column',
                        justifyContent: 'space-between',
                        flex: 1
                    }}
                >
                    <div>
                        <Autocomplete
                            value={selectedDuties}
                            multiple={true}
                            sx={{ width: '100%', paddingBottom: '1rem' }}
                            getOptionLabel={(option) => option.label || null}
                            renderOption={(props, option, { selected }) => (
                                <li {...props}>
                                    <Checkbox
                                        icon={oicon}
                                        checkedIcon={checkedIcon}
                                        style={{ marginRight: 8 }}
                                        checked={selected}
                                    />
                                    {option.label}
                                </li>
                            )}
                            onChange={(e, item) => setSelectedDuties(item)}
                            options={duties}
                            isOptionEqualToValue={(option, value) => option.value === value.value}
                            renderInput={(params) => <div>
                                <TextField {...params} placeholder="Selecione os grupos" />
                            </div>
                            }
                        />

                        <Autocomplete
                            value={selectedUsers}
                            multiple={true}
                            sx={{ width: '100%', paddingBottom: '1rem' }}
                            getOptionLabel={(option) => option || null}
                            renderOption={(props, option, { selected }) => (
                                <li {...props}>
                                    <Checkbox
                                        icon={oicon}
                                        checkedIcon={checkedIcon}
                                        style={{ marginRight: 8 }}
                                        checked={selected}
                                    />
                                    {option}
                                </li>
                            )}
                            onChange={(e, item) => setSelectedUsers(item)}
                            options={users}
                            isOptionEqualToValue={(option, value) => option === value}
                            renderInput={(params) => <div>
                                <TextField {...params} placeholder="Selecione os usuários" />
                            </div>
                            }
                        />
                    </div>

                    <Button variant="contained" onClick={onClickSendEmail} disabled={disabledButton}>
                        Enviar
                    </Button>
                </div>
            </Box>
        </Modal>
    )
}